import submitProcess from './app.vue'

function install(Vue) {
  function dialog(options = {}) {
    let submitProcessDia
    const promise = new Promise((resolve, reject) => {
      const constructor = Vue.extend(submitProcess)
      submitProcessDia = new constructor({
        el: document.createElement('div')
      })
      for (let key in options) {
        submitProcessDia[key] = options[key]
      }
      submitProcessDia.resolve = resolve
      submitProcessDia.reject = reject
      document.body.appendChild(submitProcessDia.$el)
    })
    return {
      component: submitProcessDia,
      promise
    }
  }
  Vue.prototype.$submitProcess = dialog
}
export default {
  install
}



// WEBPACK FOOTER //
// ./src/components/Stu/StuPractice/StuExam/submitProcess/index.js